export default __webpack_public_path__ + "static/media/rednessActive.2746fb4c.svg";